import { GD } from "src/GD";
import { BanksService } from "./BanksService";

// !TODO
const CLIENTS_URL: string = "https://cabinet.impaya.com/api/v2/";

export class FileService {
	constructor() {
		GD.REQ_FILES_SAVE.listener = async req => this.filesSave(req);
		GD.REQ_FILES_LIST.listener = async req => this.filesList(req);
		GD.REQ_FILE_DELETE.listener = async req => this.fileDelete(req);
		GD.REQ_FILE_DOWNLOAD.listener = async req => this.fileDownload(req);
	}

	async fileDownload(req: { target_id: number; target_type: string; id: string | number }): Promise<any> {
		return await GD.REQ_API.request({
			url: CLIENTS_URL + "files/download",
			method: "" as IAPIMethod,
			headers: { Authorization: "Basic " + BanksService.ssid },
			data: {
				target_id: req.target_id,
				target_type: req.target_type,
				id: req.id,
			},
		});
	}

	async filesSave(req: any): Promise<any> {
		return await GD.REQ_API.request({
			url: CLIENTS_URL + "files/add",
			method: "" as IAPIMethod,
			headers: { Authorization: "Basic " + BanksService.ssid },
			data: {
				target_id: req.target_id,
				target_type: req.target_type,
			},
			files: req.files,
		});
	}

	async fileDelete(req: any): Promise<any> {
		return await GD.REQ_API.request({
			url: CLIENTS_URL + "files/delete",
			method: "" as IAPIMethod,
			headers: { Authorization: "Basic " + BanksService.ssid },
			data: {
				target_id: req.target_id,
				target_type: req.target_type,
				id: req.id,
			},
		});
	}

	async filesList(req: any): Promise<IAPIResponse> {
		return await GD.REQ_API.request({
			url: CLIENTS_URL + "files/list",
			method: "" as IAPIMethod,
			headers: { Authorization: "Basic " + BanksService.ssid },
			data: {
				target_id: req.target_id,
				target_type: req.target_type,
			},
		});
	}
}
